import React, { Component } from 'react';

class StatusBar extends Component {
  render() {
    const styles = {
      bar: {
        backgroundColor: this.props.theme.first
      }
    };
    return (
      <div className="status-bar" style={styles.bar}>
        <span className="status-bar__left-text">
          Rainglow by Dayle Rees
        </span>
        <span className="status-bar__right-text">
          Ln 7, Col 19 &nbsp;&nbsp;&nbsp;Spaces: 2&nbsp;&nbsp;&nbsp; UTF-8
        </span>
      </div>
    );
  }
}

export default StatusBar;



// WEBPACK FOOTER //
// ./src/components/StatusBar.js